
import { useForm } from "react-hook-form"
import type { User } from "firebase/auth"
import type { LiveId, SpaceKey } from "popopo-msg"
import { api } from "../../core"

type SelectionCreateForms = {
  kind: "message" | "talk"
  title: string
}

export const SelectionCreateForm = (props: { firebase: User; spaceKey: SpaceKey; liveId: LiveId }) => {
  const form = useForm<SelectionCreateForms>({
    mode: "onBlur",
    defaultValues: {
      kind: "message",
      title: "",
    },
  })
  const { spaceKey, liveId } = props
  const { isSubmitting, isValid } = form.formState

  const onSubmit = async (value: SelectionCreateForms) => {
    try {
      const idToken = await props.firebase.getIdToken()
      await api.POST("/api/v2/spaces/{space_key}/lives/{live_id}/selections", {
        params: { path: { space_key: spaceKey, live_id: liveId } },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
        body: {
          kind: value.kind,
          ...(value.title !== "" ? {title: value.title} : {}),
        },
      })
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <>
      <form className="d-flex w-100 flex-column gap-3" onSubmit={form.handleSubmit(onSubmit)}>
        <div className="form-floating">
          <select className="form-control" disabled={isSubmitting} {...form.register("kind")}>
            <option value={"message"}>message</option>
            <option value={"talk"}>talk</option>
            <option value={"unknown"}>unknown</option>
          </select>
          <label>Kind</label>
        </div>

        <div className="form-floating">
          <input className="form-control" disabled={isSubmitting} {...form.register("title")} />
          <label>Title</label>
        </div>

        <button type="submit" className="btn btn-primary form-control" disabled={isSubmitting || !isValid}>
          Call &quot;POST /spaces/{spaceKey === "" ? "${key}" : spaceKey}/selections&quot; API
        </button>
      </form>
    </>
  )
}
